import { render, staticRenderFns } from "./DeleteUsers.vue?vue&type=template&id=5fdde7a9"
import script from "./DeleteUsers.vue?vue&type=script&lang=ts"
export * from "./DeleteUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports